import { flow } from 'lodash';
import trimMoreThanOneSpace from '../../../utils/trimMoreThanOneSpace';
import trimLineBreaks from '../../../utils/trimLineBreaks';

export default flow(
  trimMoreThanOneSpace,
  trimLineBreaks,
);
